import { render, staticRenderFns } from "./ExamineeInstructionsModal.vue?vue&type=template&id=6d865c23&scoped=true&"
import script from "./ExamineeInstructionsModal.vue?vue&type=script&lang=js&"
export * from "./ExamineeInstructionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d865c23",
  null
  
)

export default component.exports